"use client";

import { useContext, useEffect, useState } from "react";
import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { applyQRFormDefaultValues } from "@/utils/formHelper";
import { omittedValues } from "@/utils/qrEditorHelper";
import { qrUrlValidation } from "@/utils/validators/qr-url";
import { QRUrlProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export function QRUrl({ data }: QRUrlProps) {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = useContext<QREditorContextProps<"url">>(QREditorContext);

  const [qrUrlData, setQrUrlData] = useState<QRProps<"url">>(qrData);
  const [renderForm, setRenderForm] = useState(false);

  const dataUrlWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }) => {
    if (field == "") return;
    setQrData({ ...qrData, data: { ...qrData.data, [field]: value } }, omittedValues(qrData.data));
  };

  useEffect(() => {
    setQrUrlData(qrData);
  }, [qrData]);

  useEffect(() => {
    setQrData({ ...qrUrlData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-url">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataUrlWithDefaultValues}
        schema={qrUrlValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
}
